/**
 * Searches for existing document that matches the ISBN or title
 * @param {string} isbnValue - The ISBN to search for
 * @param {string} title - The book title to search for
 * @returns {Promise<string|null>} - Document PID if found, null otherwise
 */
export const searchForDocument = async (isbnValue, title) => {
  try {
    // Import documentApi
    const { documentApi } = await import("@api/documents");

    // First, search by ISBN
    let searchQuery = `identifiers.value:"${isbnValue}"`;
    let response = await documentApi.list(searchQuery);

    if (response.data.hits && response.data.hits.length > 0) {
      return response.data.hits[0].metadata.pid;
    }

    // If no ISBN match, search by title
    if (title) {
      searchQuery = `title:"${title}"`;
      response = await documentApi.list(searchQuery);

      if (response.data.hits && response.data.hits.length > 0) {
        return response.data.hits[0].metadata.pid;
      }
    }

    return null;
  } catch (error) {
    return null;
  }
};
